import { useMemo } from 'react'
import React from 'react'

import { EngagementScoreFlames } from 'components/EngagementScoreFlames'
import EngagementScoreIndicator, { scoreToIndicator } from 'components/EngagementScoreIndicator'
import { scoreToDescription } from 'components/Explain'

import { ReactComponent as Gauge1 } from './gauge-1.svg'
import { ReactComponent as Gauge2 } from './gauge-2.svg'
import { ReactComponent as Gauge3 } from './gauge-3.svg'
import { ReactComponent as Gauge4 } from './gauge-4.svg'
import { ReactComponent as Gauge5 } from './gauge-5.svg'

import styles from './styles.module.css'

interface RadialEngagementScoreProps {
  score: number
  prevScore?: number
}

export const RadialEngagementScore = ({ score, prevScore }: RadialEngagementScoreProps) => {
  const scoreDiff = Math.abs(score - (prevScore || 0))
  const BackgroundGauge = useMemo(() => {
    switch (score) {
      case 1:
        return <Gauge1 />
      case 2:
        return <Gauge2 />
      case 3:
        return <Gauge3 />
      case 4:
        return <Gauge4 />
      case 5:
        return <Gauge5 />
      default:
        return <Gauge3 />
    }
  }, [score])

  return (
    <div
      style={{
        height: 180,
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      {BackgroundGauge}
      <div className={styles.engagementAbsoluteCont}>
        <h2 className={styles.numberTextStyle}>{score}</h2>
        <p className={styles.subTextStyle}>{scoreToDescription(Math.min(Math.round(score), 5))}</p>
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}>
          <EngagementScoreFlames score={score} />
          {prevScore && (
            <>
              <EngagementScoreIndicator variant={scoreToIndicator(score, prevScore)} />
              {prevScore !== score && (
                <span
                  className={styles.indicatorTextStyle}
                  style={{
                    ...(score - prevScore > 0
                      ? { color: '#70C198' }
                      : { color: 'var(--color-s3-6)' })
                  }}>
                  {score - prevScore > 0 ? '+' : '-'}
                  {scoreDiff.toFixed(scoreDiff < 1 ? 1 : 0)}
                </span>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}
